// returns an object having this interface:
// (depending on input, some properties might be missing)
// {
// 	allStim:,
// 	allTrial:,
// 	ITI:,
// 	afterStim:,
// 	withResponse:,
// 	screens: [
// 		withStim:,
// 		ISI
// 	]
// }

function initTrialText(trialTextValue, trialTextOptionsValue, numberOfScreens) {
	var trialTexts = parseTrialText(trialTextValue);
	var trialTextOptions = parseTrialTextOptions(trialTextOptionsValue);
	var screensTexts = {
		screens: []
	};

	var getNextText = buildArrayEndlessIterator(trialTexts);
	var hasWithStim = trialTextOptions.indexOf('withStim') >= 0;
	var hasAllStim = trialTextOptions.indexOf('allStim') >= 0;
	var hasAllTrial = trialTextOptions.indexOf('allTrial') >= 0;
	var hasISI = trialTextOptions.indexOf('ISI') >= 0;

	//ITI
	if (trialTextOptions.indexOf('ITI') >= 0) {
		screensTexts.ITI = getNextText();
	}

	//allTrial
	if (hasAllTrial) {
		screensTexts.allTrial = getNextText();
	}

	//allStim
	if (hasAllStim) {
		screensTexts.allStim = getNextText();
	}

	//ignore to prevent overlap
	if (!hasAllStim && !hasAllTrial) {
		//firstStim
		var screensIndex = 0;
		if (trialTextOptions.indexOf('firstStim') >= 0) {
				screensTexts.screens[0] = {
					withStim: getNextText(),
					ISI: hasISI ? getNextText() : ""
				};

				screensIndex = 1;
		}

		//withStim and ISI
		while ( screensIndex < numberOfScreens ) {
			var isLastScreen = screensIndex + 1 == numberOfScreens;
			screensTexts.screens.push({
				withStim: hasWithStim ? getNextText() : "",
				ISI: hasISI && !isLastScreen? getNextText() : ""
			});

			screensIndex++;
		}

		//lastStim
		if (trialTextOptions.indexOf('lastStim') >= 0) {
			screensTexts.screens[screensTexts.screens.length - 1].withStim = getNextText();
		}
	}

	//ignore to prevent overlap
	if (!hasAllTrial) {
		//afterStim
		if (trialTextOptions.indexOf('afterStim') >= 0) {
			screensTexts.afterStim = getNextText();
		}
	}


	//withResponse
	if (trialTextOptions.indexOf('withResponse') >= 0) {
		screensTexts.withResponse = getNextText();
	}

	return screensTexts;

	//private functions
	function parseTrialText(trialTextValue) {
		var trialTexts = [];

		if (!trialTextValue || trialTextValue === 'na') {
			return trialTexts;
		}

		if (trialTextValue[0] != "{" && trialTextValue[0] != "}") {
			trialTexts.push(trialTextValue);
			return trialTexts;
		}

		// remove  first and last { }
		trialTextValue = trialTextValue.substring(1, trialTextValue.length -1);

		trialTexts = trialTextValue.split("}{");

		return trialTexts;
	}

	function parseTrialTextOptions(trialTextOptionsValue) {
		var trialTextOptions = [];

		if (!trialTextOptionsValue || trialTextOptionsValue === 'na') {
			// default options
			trialTextOptionsValue = 'lastStim;afterStim';
		}

		trialTextOptions = trialTextOptionsValue.split(';');

		//curate the values
		var trialTextOptionsValidValues = ['ITI', 'ISI', 'allStim', 'withStim', 'allTrial', 'firstStim', 'lastStim', 'afterStim', 'withResponse'];
		trialTextOptions = trialTextOptions.filter(function(value) {
			return trialTextOptionsValidValues.indexOf(value) >= 0;
		});

		return trialTextOptions;
	}

	//returns a function that on sequential calls returns the next item in the original array or last available value
	function buildArrayEndlessIterator(arr) {
		var arrCopy = arr.slice();
		var lastAvailableValue = "";
		return function() {
			lastAvailableValue = arrCopy.length ? arrCopy.shift() : lastAvailableValue;
			return lastAvailableValue;
		}
	}
}


function showTrialTextForScreen(trialRow, currentScreenIndex, isForISI) {

	//nothing to show if text is already on the screen
	if (listTrialTexts.allTrial  || listTrialTexts.allStim) {
		return;
	}

	var propKey = isForISI ? 'ISI' : 'withStim';

	//double check we have defined the text for this screen
	if (!listTrialTexts[trialRow] || !listTrialTexts[trialRow].screens || !listTrialTexts[trialRow].screens[currentScreenIndex] || !listTrialTexts[trialRow].screens[currentScreenIndex][propKey]) {
		return;
	}

	var text = listTrialTexts[trialRow].screens[currentScreenIndex][propKey];


	if (isForISI) {
		var withStimText = listTrialTexts[trialRow].screens[currentScreenIndex].withStim;
		if (withStimText != text) {
			//is for ISI and ISI text != withStim text then vertically center the text for ISI
			minImagesTop = Number.POSITIVE_INFINITY;
			showTrialText(text);
		}
	}

	var lastResponse = window.responses[window.responses.length - 1];
	var lastRT = window.RTs[window.RTs.length - 1];
	var lastCorrect = window.correct[window.correct.length - 1];

	text = replaceVariables(text, lastResponse, lastRT, lastCorrect, 1);

	showTrialText(text);
}

function showTrialTextISIForScreen(trialRow, currentScreenIndex) {
	showTrialTextForScreen(trialRow, currentScreenIndex, true);
}

function showTrialTextAfterStim(trialRow) {
	var text;
	//do not show as we have allTrial defined
	if (listTrialTexts[trialRow].allTrial) {
		return;
	}

	text = listTrialTexts[trialRow] && listTrialTexts[trialRow].afterStim;

	//check last withStim
	var lastWithStim = listTrialTexts[trialRow].screens[listTrialTexts[trialRow].screens.length - 1] && listTrialTexts[trialRow].screens[listTrialTexts[trialRow].screens.length - 1].withStim;
	//check allStim
	var allStim = listTrialTexts[trialRow].allStim;

	if (lastWithStim != text && allStim != text) {
		minImagesTop = Number.POSITIVE_INFINITY;
	}

	if (!text) {
		return;
	}

	showTrialText(text);
}

function showTrialTextITI(trialRow) {

	var text = listTrialTexts[trialRow].ITI;

	if (!text) {
		return;
	}

	//align with allStim OR allTrial
	var allStim = listTrialTexts[trialRow].allStim;
	var allTrial = listTrialTexts[trialRow].allTrial;
	if ( text == allStim || text == allTrial ) {
		//align with all screens
		showTrialText(text, window.minTrialAllImagesTop);
		return;
	}

	//vertically center if text != firstStimText
	//default aligns with firstStimText
	var firstStimText = listTrialTexts[trialRow].screens[0] && listTrialTexts[trialRow].screens[0].withStim;
	if ( text != firstStimText ) {
		minImagesTop = Number.POSITIVE_INFINITY;
	}

	showTrialText(text);
}

function showTrialTextWithResponseWindow(trialRow) {
	console.log('SHOW Response Text');
	listTrialTexts[trialRow].withResponse && showTrialText(listTrialTexts[trialRow].withResponse, window.minTrialAllImagesTop || window.minImagesTop, false);
}

function showTrialTextAllStim(trialRow, minTrialAllImagesTop) {
	if (window.isActiveResponseWindow && listTrialTexts[trialRow].withResponse) {
		return;
	}

	listTrialTexts[trialRow].allStim && !listTrialTexts[trialRow].allTrial && showTrialText(listTrialTexts[trialRow].allStim, minTrialAllImagesTop);
}

function showTrialTextAllTrial(trialRow, minTrialAllImagesTop) {
	if (window.isActiveResponseWindow && listTrialTexts[trialRow].withResponse) {
		return;
	}

	listTrialTexts[trialRow].allTrial && showTrialText(listTrialTexts[trialRow].allTrial, minTrialAllImagesTop);//all trial has higher priority over allStim
}

function hideTextAfterLastStim(trialRow) {
	//do not hide as we have allTrial defined
	if (listTrialTexts[trialRow].allTrial) {
		return;
	}

	hideTrialText(trialRow, true);
}

function hideTrialText(trialRow, forceHide) {
	if (!forceHide && (listTrialTexts[trialRow].allTrial  || listTrialTexts[trialRow].allStim)) {
		return;
	}

	if (window.isActiveResponseWindow && listTrialTexts[trialRow].withResponse) {
		return;
	}

	 document.getElementById('trialText').style.display = 'none';
}